import { Inject, Injectable } from '@angular/core';
import { DeviceDetector } from '@platform-frontend/checkout-drop-in';
import { WINDOW } from '@platform-frontend/util';

@Injectable({
  providedIn: 'root'
})
export class MobileService {
  constructor(@Inject(WINDOW) private window: Window) {}

  private deviceDetector = new DeviceDetector();

  isMobileDevice(): boolean {
    return this.deviceDetector.isMobile();
  }

  isAppleDevice(): boolean {
    return this.deviceDetector.isAppleDevice();
  }

  isIOSDevice(): boolean {
    return this.deviceDetector.isIOSDevice();
  }

  isMobileScreenSize(): boolean {
    return this.window.innerWidth < 768;
  }
}
